import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom'

import { Layout } from '@/components/layout'
import { ROUTES, ROUTE_POLICIES, getRoutePolicyById } from '@/constants'
import { LoginPage, RequireSession } from '@/features/auth'

import { HomeRedirect, ProtectedLazy, AppearanceRoute, SettingsRoute } from './route-elements'
import { RouteErrorBoundary } from './RouteErrorBoundary'

function buildProtectedRoute(policyId: string): RouteObject {
  return {
    path: getRoutePolicyById(
      policyId as (typeof ROUTE_POLICIES)[number]['id'],
    ).path,
    element: <ProtectedLazy loaderKey={policyId} />,
    errorElement: <RouteErrorBoundary />,
  }
}

const appChildren: RouteObject[] = ROUTE_POLICIES.map((policy) =>
  buildProtectedRoute(policy.id),
)

appChildren.push(
  { index: true, element: <HomeRedirect /> },
  {
    path: ROUTES.INVENTORY.MOVEMENTS,
    element: <Navigate to={ROUTES.INVENTORY.LOTS} replace />,
  },
  {
    path: ROUTES.INVENTORY.INTAKE,
    element: <Navigate to={ROUTES.INVENTORY.LOTS} replace />,
  },
  {
    path: ROUTES.INVENTORY.ADJUSTMENTS,
    element: <Navigate to={ROUTES.INVENTORY.LOTS} replace />,
  },
  {
    path: ROUTES.ADMIN.SETTINGS,
    element: <SettingsRoute />,
    children: [
      {
        index: true,
        element: <Navigate to={ROUTES.ADMIN.SETTINGS_APPEARANCE} replace />,
      },
      {
        path: ROUTES.ADMIN.SETTINGS_APPEARANCE,
        element: <AppearanceRoute />,
      },
    ],
  },
)

export const router = createBrowserRouter([
  {
    path: ROUTES.LOGIN,
    element: <LoginPage />,
  },
  {
    element: <RequireSession />,
    children: [
      {
        path: ROUTES.HOME,
        element: <Layout />,
        children: appChildren,
      },
    ],
  },
])
